import request from "../base-request";

type ChangeDirectoryFieldsResponse = {
	errors: string[];
};

/**
 * Saves the directory column configuration.
 *
 * Posts to the legacy Tornado endpoint, which reads its payload with `get_argument` — so the
 * body has to be form-encoded with a JSON `data` value rather than a JSON document. Only the
 * `dir` key is sent; omitting `org` preserves the separately configurable Org Chart card fields.
 */
export const saveDirectoryColumns = async (directoryFieldIds: string[]) => {
	const body = new URLSearchParams({ data: JSON.stringify({ dir: directoryFieldIds }) });

	const [response] = await request<ChangeDirectoryFieldsResponse>("/ajax/change-directory-fields/", {
		method: "POST",
		headers: { "Content-Type": "application/x-www-form-urlencoded" },
		body: body.toString(),
	});

	return response;
};
